import React from "react";

function Icon(props) {
  return (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        strokeLinejoin="round"
        strokeMiterlimit="2"
        clipRule="evenodd"
        viewBox="0 0 113 113"
        height={props.height ? props.height : "22px "}
    >
      <path
        className={props.pathClass ? props.pathClass : "black"}
        d="M9024.11 11411.3c4.38 0 7.94 3.5 7.94 7.9s-3.56 7.9-7.94 7.9c-4.38 0-7.93-3.5-7.93-7.9s3.55-7.9 7.93-7.9zm32.63 0c4.38 0 7.94 3.5 7.94 7.9s-3.56 7.9-7.94 7.9c-4.38 0-7.93-3.5-7.93-7.9s3.55-7.9 7.93-7.9zm32.63 0c4.38 0 7.94 3.5 7.94 7.9s-3.56 7.9-7.94 7.9c-4.37 0-7.93-3.5-7.93-7.9s3.56-7.9 7.93-7.9z"
        transform="translate(-8995.12 -11363)"
      ></path>
      <path
        fill="none"
        d="M7743.43 11233.1H7802.857V11302.999H7743.43z"
        transform="matrix(1.89741 0 0 1.60953 -14692.4 -18080)"
      ></path>
    </svg>
  );
}

export default Icon;
